/**
 * @constructor
 * @implements {Foundation.View.Interface.ModalDialog2}
 * @param {jQuerySelector?} viewSelector
 * @extends {Foundation.Promise}
 */
Foundation.View.Mobile.ModalDialog2 = function (viewSelector) {
    Foundation.Promise.call(this);
    
    /** @type {Foundation.Spinner} */
    this.spinner = null;
    
    /** @type {!Foundation.Promise} */
    this.closedPromise = new Foundation.Promise();
    
    /** @type {jQuery} */
    this.view = null;
    this.setView(viewSelector);
};
Foundation.inherit(Foundation.View.Mobile.ModalDialog2, Foundation.Promise);

Foundation.View.Mobile.ModalDialog2.prototype.closed = function () {
    return this.closedPromise;
};

/**
 * @param {jQuerySelector?} viewSelector
 */
Foundation.View.Mobile.ModalDialog2.prototype.setView = function (viewSelector) {
    Foundation.documentReady.then(function () {
        if (!viewSelector) {
            this.spinner = new Foundation.View.Spinner();
        }
        else {
            if (this.spinner) this.spinner.hide();
            this.view = jQuery(viewSelector);
            this.view.appendTo(document.body);


            this.view = jQuery('div#LoginDialogMobile');

            this.view.modal('setting', {
                onVisible    : this.fulfill.bind(this),
                onHidden : this.closed().fulfill.bind(this.closed())
            });
            this.view.modal('show');
        }
    }.bind(this));
};

/**
 * Close the dialog.
 */
Foundation.View.Mobile.ModalDialog2.prototype.close = function () {
    if (this.spinner) this.spinner.hide();
    this.then(function () {
        if (this.view) this.view.modal("hide");
    }.bind(this));
};

/**
 * Destructor. Will remove the dialog page element from the DOM.
 * @override
 */
Foundation.View.Mobile.ModalDialog2.prototype.destroy = function () {
    if (this.spinner) this.spinner.hide();
    if (this.view) {
        this.view.remove();
        this.view = null;
    }
    Foundation.Promise.prototype.destroy.call(this);
};

/**
 * On a redraw, bring the user back up to the top of the dialog.
 */
Foundation.View.Mobile.ModalDialog2.prototype.redraw = function () {
    //jQuery.mobile.silentScroll(0);
    this.view.modal('refresh');
};


Foundation.View.ModalDialog = Foundation.View.Mobile.ModalDialog2;

